<template>
  <form class="flex flex-col items-center gap-4 mb-6 dark:text-white sm:flex-row" @submit.prevent>
    <input
      v-model="search"
      type="text"
      placeholder="Search..."
      class="w-48 px-3 py-2 border rounded dark:border-gray-600"
    />
    <select
      v-if="isCategories && categories.length > 0"
      v-model="category"
      class="px-3 py-2 border rounded dark:border-gray-600"
    >
      <option value="">All Categories</option>
      <option v-for="cat in categories" :key="cat" :value="cat.id ? cat.id : cat">
        {{ cat.name ?? cat }}
      </option>
    </select>
    <select
      v-if="isSubCategories && filteredSubcategories.length > 0"
      v-model="subcategory"
      class="px-3 py-2 border rounded dark:border-gray-600"
      :disabled="!category"
    >
      <option value="">All Subcategories</option>
      <option v-for="sub in filteredSubcategories" :key="sub" :value="sub">
        {{ sub }}
      </option>
    </select>
  </form>
</template>

<script setup>
import { useDebounceFn } from '@vueuse/core'
import { ref, computed, reactive, watch, toRefs } from 'vue'

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({ search: '', category: '', subcategory: '' })
  },
  categories: {
    type: Array,
    default: () => []
  },
  subcategories: {
    type: Array,
    default: () => []
  },
  isSubCategories: {
    type: Boolean,
    default: false
  },
  isCategories: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['update:modelValue'])

const category = ref(props.modelValue.category)
const subcategory = ref(props.modelValue.subcategory)
const search = ref(props.modelValue.search)

const localFilters = reactive({ ...props.modelValue })

watch(() => props.modelValue, (val) => {
  Object.assign(localFilters, val)
})

const filteredSubcategories = computed(() => {
  if (!localFilters.category) return props.subcategories
  return props.subcategories.filter(
    sub => sub.category_id === localFilters.category
  )
})

function emitFilters() {
    emit('update:modelValue', { search: search.value, category: category.value, subcategory: subcategory.value })
}

// Debounced search filter
const debouncedSearch = useDebounceFn(() => {
    emitFilters()
}, 500)

watch(search, debouncedSearch)

// Immediate emit for category and subcategory
watch([
    () => category.value,
    () => subcategory.value
], () => {
    emitFilters()
})

</script>

<style scoped>
form {
  width: 100%;
}
input, select {
  min-width: 150px;
}
</style>
